import React, { PropTypes } from 'react';
import TableRow from './TableRow';

const TableRows = ({
    content,
    onClick,
    onShowInfo,
    onCopy,
    defaultContent,
    chain,
    hotel,
    setData,
    contenttype,
    itemName,
    uploadUrl,
    category
}) => {
    return (
        <tbody>
            {content.map(item => {
                return (
                    <TableRow
                        key={item.level + ':' + item.ContentCode + '-'}
                        item={item}
                        defaultContent={defaultContent}
                        onClick={() => onClick(item.code)}
                        onShowInfo={onShowInfo}
                        onCopy={onCopy}
                        chain={chain}
                        hotel={hotel}
                        setData={setData}
                        contenttype={contenttype}
                        uploadUrl={uploadUrl}
                        itemName={itemName}
                        category={category}
                    />
                );
            })}
        </tbody>
    );
};

TableRows.propTypes = {
    category: PropTypes.string,
    content: PropTypes.array,
    onClick: PropTypes.func,
    onShowInfo: PropTypes.func,
    onCopy: PropTypes.func,
    setData: PropTypes.func,
    defaultContent: PropTypes.object,
    contenttype: PropTypes.string,
    uploadUrl: PropTypes.string,
    itemName: PropTypes.string
};

export default TableRows;



// WEBPACK FOOTER //
// ./src/components/pages/manage/common/TableRows.js